import Vue from 'vue'
import Vuex from 'vuex'
// import { stat } from 'fs';

import sample from './modules/sample';
import user from './modules/user';
import dialog from './modules/dialog';
import vtxcheckboxes from './modules/vtxcheckboxes';
import vdxcheckboxes from './modules/vdxcheckboxes';

import { HTTP } from '@/utilities/http-common';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    sample: sample,
    user: user,
    dialog: dialog,
    vtxcheckboxes: vtxcheckboxes,
    vdxcheckboxes: vdxcheckboxes
  },
  state: {
    component: 'BaseTemplate',
    Authorization: '',
    authorizationExpiresAt: null,
    // loginDialog: false,
    
    // messageDialog: false,
    // messageDialogMessage: 'An error occured!',

    // loadingDialog: false,
    // loadingDialogMessage: ''

    sidebar: true,

  },
  getters: {
    getBaseComponent: state => {
      return state.component;
    },
    isAuthenticated: state => {
      //return (state.Authorization) ? true : false;
      return Boolean(state.Authorization) && Date.now() < Number(state.authorizationExpiresAt)
    },
    hasAuthorizationToken: state => {
      let Authorization = window.localStorage.getItem('Authorization');
      if (Authorization) {
        state.Authorization = Authorization;
        return true;
      } else {
        return false;
      }
    },
    getAuthorizationToken: state => {
      return state.Authorization;
    },
    getAuthorizationHeader: (state, getters) => {
      return (state.Authorization) ? { Authorization: getters.getAuthorizationToken } : {};
    }
  },
  mutations: {
    setBaseComponent(state, component) {
      state.component = component;
    },
    setAuthorizationToken(state, payload) {
      state.Authorization = payload.token_type + ' ' + payload.access_token;
      // state.authorizationExpiresAt = Date.now() + (payload.expires_in * 1000);
      state.authorizationExpiresAt = Date.now() + (16 * 60 * 60 * 1000); // 16 hours until force log-out

      HTTP.defaults.headers.common['Authorization'] = state.Authorization;
      window.localStorage.setItem('Authorization', state.Authorization);
      window.localStorage.setItem(
        'authorizationExpiresAt',
        String(state.authorizationExpiresAt)
      );
    },
    setAuthorization(state, payload) {
      state.Authorization = payload;
      HTTP.defaults.headers.common['Authorization'] = state.Authorization;
    },
    setAuthorizationExpiry(state, payload) {
      state.authorizationExpiresAt = payload;
    },
    clearAuthorizationToken (state) {
      state.Authorization = '';
      state.authorizationExpiresAt = null;
      window.localStorage.removeItem('Authorization');
      window.localStorage.removeItem('authorizationExpiresAt');
      HTTP.defaults.headers.common['Authorization'] = undefined;
    },
    toggleSidebar: (state) => {
      state.sidebar = !state.sidebar;
    }
  },
  actions: {
    setAuthorizationToken ({commit}, payload) {
      commit('setAuthorizationToken', payload);
    },
    clearAuthorizationToken({commit}) {
      commit('clearAuthorizationToken');
    },
    setBaseComponent ({commit}, component) {
      commit('setBaseComponent', component);
    },
    initApp({dispatch}) {
      dispatch('initAuthorizationToken');
    },
    initAuthorizationToken({ commit, dispatch }) {
      const authorization = localStorage.getItem('Authorization');
      const expiresAt = Number(localStorage.getItem('authorizationExpiresAt'));
    
      if (!authorization || !expiresAt || Date.now() >= expiresAt) {
        dispatch('clearAuthorizationToken');
        return false;
      }
    
      commit('setAuthorization', authorization);
      commit('setAuthorizationExpiry', expiresAt);
      return true;
    },
    // initAuthorizationToken({commit}) {
    //   let Authorization = window.localStorage.getItem('Authorization');
    //   if (Authorization) {
    //     commit('setAuthorization', Authorization);
    //   } else {
    //     return false;
    //   }
    // },
    toggleSidebar({commit}) {
      commit('toggleSidebar');
    },

  }
})
